import React from 'react';

import { Typography, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginTop: '6.5rem',
    [theme.breakpoints.down('sm')]: {
      marginTop: '2.5rem'
    }
  },
  textBox: {
    width: '65%',
    padding: '2.75rem 5.125rem ',
    borderTop: '1px black solid',
    borderBottom: '1px black solid',
    [theme.breakpoints.down('sm')]: {
      width: '86%',
      padding: '2rem 0'
    }
  },
  pg1: {
    marginTop: '1.5rem',
    [theme.breakpoints.down('sm')]: {
      marginTop: '1rem'
    }
  },
  bolded: {
    ...theme.typography.body2,
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      lineHeight: '28px'
    }
  },
  mobileH3: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
      lineHeight: '18px'
    }
  },
  mobileBody1: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      lineHeight: '28px',
      letterSpacing: '.5px'
    }
  }
}));

const ComingTogether = () => {
  const classes = useStyles();
  return (
    <Grid container direction="column" alignItems="center" className={classes.wrapper}>
      <Grid container direction="column" className={classes.textBox}>
        <Grid item>
          <Typography variant="h3" className={classes.mobileH3}>
            COMING TOGETHER
          </Typography>
        </Grid>
        <Grid item className={classes.pg1}>
          <Typography variant="body1" className={classes.mobileBody1}>
            Pat and Nikki’s bond grew over the phone in the midst of the COVID-19 pandemic. With
            Nikki’s help, Pat was able to schedule a bone scan, which ultimately led to a diagnosis
            of osteoporosis; get a vision scan and new glasses; and schedule her COVID-19 vaccines.
            Nikki even helped Pat get a cell phone for the first time.
          </Typography>
        </Grid>
        <Grid item className={classes.pg1}>
          <Typography variant="body1" className={classes.mobileBody1}>
            With both women now fully vaccinated, Pat was finally able to show Nikki her “little
            house in the big yard” in person.
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ComingTogether;
